export const SET_ADMISSION_SEMAPHORE_REQUEST = 'SET_ADMISSION_SEMAPHORE_REQUEST';
export const SET_ADMISSION_SEMAPHORE_SUCCESSFULLY = 'SET_ADMISSION_SEMAPHORE_SUCCESSFULLY';
export const SET_ADMISSION_SEMAPHORE_ERROR = 'SET_ADMISSION_SEMAPHORE_ERROR';

export const RESET_ADMISSION_SEMAPHORE_REQUEST = 'RESET_ADMISSION_SEMAPHORE_REQUEST';
export const RESET_ADMISSION_SEMAPHORE_SUCCESSFULLY = 'RESET_ADMISSION_SEMAPHORE_SUCCESSFULLY';
export const RESET_ADMISSION_SEMAPHORE_ERROR = 'RESET_ADMISSION_SEMAPHORE_ERROR';

